import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'productShopPanel',
    serviceName: 'grapghql',
    query: gql`
      query productShopPanel($ids: [String], $for_admin: Int) {
        productShopPanel(ids: $ids, for_admin: $for_admin) {
          data {
            wolesale_discounts {
              quantity
              discount_amount
              discount_percent
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'updateWolesaleDiscountTotality',
    serviceName: 'shopadmin',
    query: gql`
      mutation update($wolesale_items: [WolesaleItemInput]!) {
        updateWolesaleDiscountTotality(wolesale_items: $wolesale_items) {
          messages
        }
      }
    `,
  },
  delete: {
    name: 'deleteWolesaleDiscountTotality',
    serviceName: 'shopadmin',
    query: gql`
      mutation update($product_shop_id: String!) {
        deleteWolesaleDiscountTotality(product_shop_id: $product_shop_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
